import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CV_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#CV_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#4141DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CV_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#CV_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 13h-1v4h34v-4H0z",
      fill: "#F90000",
      stroke: "#F7FCFF",
      strokeWidth: 2
    }
  ), /* @__PURE__ */ e.createElement("g", { filter: "url(#CV_svg__filter0_d_4799_265846)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.796 10.26l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573-.245.906zm3 1.6l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.74-.282.74h-.843l.645.574-.245.905zm3.126 1.89l-.726.51.246-.906-.645-.574h.842l.282-.739.332.74h.717l-.564.573.219.906-.703-.51zm-.726 4.51l.726-.51.703.51-.219-.906.564-.574h-.717l-.332-.739-.282.74h-.842l.645.573-.245.906zm-1.674 1.891l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906-.702-.509zM9.796 22.26l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.282.74h-.843l.645.573-.245.906zM7.522 20.15l-.726.509.245-.906-.645-.574h.843l.282-.739.331.74h.718l-.564.573.218.906-.702-.509zM4.396 18.26l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.739-.283.74h-.842l.645.573-.245.906zm.726-4.51l-.726.51.245-.906-.645-.574h.842l.283-.739.33.74h.719l-.564.573.218.906-.702-.51zm1.674-1.89l.726-.51.702.51-.218-.906.564-.574h-.718l-.331-.74-.282.74h-.843l.645.574-.245.905z",
      fill: "#FFDE00"
    }
  )))),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "filter",
    {
      id: "CV_svg__filter0_d_4799_265846",
      x: -4e-3,
      y: 4.041,
      width: 20.975,
      height: 22.219,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    },
    /* @__PURE__ */ e.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
    /* @__PURE__ */ e.createElement(
      "feColorMatrix",
      {
        in: "SourceAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }
    ),
    /* @__PURE__ */ e.createElement("feOffset", null),
    /* @__PURE__ */ e.createElement("feGaussianBlur", { stdDeviation: 2 }),
    /* @__PURE__ */ e.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" }),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4799_265846"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "feBlend",
      {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4799_265846",
        result: "shape"
      }
    )
  ))
);
export {
  t as default
};
